import React from 'react';
import styles from './Divider.module.scss';

export default function Divider({ id, style }: { id?: string, style?: React.CSSProperties }) {
  return <div className={styles.divider} id={id} style={style}></div>;
}
